import React, { useState, useEffect } from "react";
import {
  Box,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  Typography,
  Divider,
  IconButton,
} from "@mui/material";
import { Logout, CalendarToday, Language, Business } from "@mui/icons-material";
import { useAppContext } from "../../AppContext";
import MPLoginWithPhoneNumberModal from "./MPLoginWithPhoneNumberModal";
import { useTranslation } from "react-i18next";
import Blogo2 from "../../Images/Blogo2.png";
import user2 from "../../Images/user2.png";
import languagebutton from "../../Images/languagebutton.png";
import { useHistory } from "react-router-dom";
import Bokahitlogo2nobgc from "../../Images/Bokahitlogo2nobgc.png";

const C = {
  primary: "#1A1A2E",
  accent: "#C9A84C",
  accentMuted: "rgba(201,168,76,0.1)",
  accentShadow: "rgba(201,168,76,0.25)",
  border: "#e5e7eb",
  textMuted: "#6b7280",
};

const pillStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  padding: "6px 14px",
  fontSize: "13px",
  fontWeight: "600",
  borderRadius: "50px",
  border: `1.5px solid ${C.border}`,
  backgroundColor: "#fff",
  color: C.primary,
  cursor: "pointer",
  transition: "all 0.25s ease",
  outline: "none",
  whiteSpace: "nowrap",
};

export default function MPHeader1() {
  const history = useHistory();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { t, i18n } = useTranslation();
  const { User, setUser } = useAppContext();
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [langAnchorEl, setLangAnchorEl] = useState(null);
  const userMenuOpen = Boolean(anchorEl);
  const langMenuOpen = Boolean(langAnchorEl);

  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) setUser(JSON.parse(savedUser));
  }, [setUser]);

  const handleLoginClick = () => setLoginModalOpen(true);
  const handleCloseLoginModal = () => setLoginModalOpen(false);
  const handleUserMenuClick = (e) => setAnchorEl(e.currentTarget);
  const handleUserMenuClose = () => setAnchorEl(null);
  const handleLangMenuClick = (e) => setLangAnchorEl(e.currentTarget);
  const handleLangMenuClose = () => setLangAnchorEl(null);

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", JSON.stringify(lang));
    localStorage.setItem("hasVisited", "true");
    handleLangMenuClose();
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    handleUserMenuClose();
  };

  const handleMyAppointments = () => {
    history.push(`/client-appointments`);
    handleUserMenuClose();
  };

  const handleListBusiness = () => {
    history.push(`/landing-page`);
  };

  const hoverGold = (e) => {
    e.currentTarget.style.borderColor = C.accent;
    e.currentTarget.style.color = C.accent;
    e.currentTarget.style.boxShadow = `0 2px 10px ${C.accentShadow}`;
    e.currentTarget.style.transform = "translateY(-1px)";
  };
  const unhoverGold = (e) => {
    e.currentTarget.style.borderColor = C.border;
    e.currentTarget.style.color = C.primary;
    e.currentTarget.style.boxShadow = "none";
    e.currentTarget.style.transform = "translateY(0)";
  };

  const isMobile = windowWidth <= 1024;

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: isMobile ? "10px 16px 6px" : "12px 24px",
          borderBottom: `1px solid ${C.border}`,
          backgroundColor: "#fff",
          position: "relative",
        }}
      >
        {/* Left: Language selector (desktop) */}
        {!isMobile && (
          <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
            <button
              onClick={handleLangMenuClick}
              style={pillStyle}
              onMouseEnter={hoverGold}
              onMouseLeave={unhoverGold}
            >
              <img
                src={languagebutton}
                alt="language"
                style={{ width: "16px", height: "16px", objectFit: "contain" }}
              />
              {i18n.language === "sv"
                ? "Svenska"
                : i18n.language === "en"
                  ? "English"
                  : "العربية"}
            </button>
          </div>
        )}

        {/* Center: Logo */}
        <div style={isMobile ? {} : { position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
          <a
            href="/"
            style={{ display: "flex", alignItems: "center", textDecoration: "none" }}
          >
            <img
              src={Bokahitlogo2nobgc}
              alt="Bokahit"
              style={{ height: isMobile ? "34px" : "44px", objectFit: "contain" }}
            />
          </a>
        </div>

        {/* Right: actions */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flex: isMobile ? "unset" : 1,
            justifyContent: "flex-end",
            marginLeft: "auto",
          }}
        >
          {!isMobile && (
            <button
              style={pillStyle}
              onClick={handleListBusiness}
              onMouseEnter={hoverGold}
              onMouseLeave={unhoverGold}
            >
              <Business sx={{ fontSize: "16px" }} />
              {t("ListYourBusiness") || "List Your Business"}
            </button>
          )}

          {User ? (
            <button
              onClick={handleUserMenuClick}
              style={pillStyle}
              onMouseEnter={hoverGold}
              onMouseLeave={unhoverGold}
            >
              {!isMobile && (
                <img
                  src={user2}
                  alt="User"
                  style={{ width: "16px", height: "16px", objectFit: "contain" }}
                />
              )}
              {isMobile ? (
                <img
                  src={user2}
                  alt="User"
                  style={{ width: "20px", height: "20px", objectFit: "contain" }}
                />
              ) : (
                User.name || t("user")
              )}
            </button>
          ) : (
            <button
              onClick={handleLoginClick}
              style={{
                ...pillStyle,
                backgroundColor: C.primary,
                color: C.accent,
                border: "none",
                boxShadow: `0 2px 10px rgba(26,26,46,0.2)`,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#16213E";
                e.currentTarget.style.transform = "translateY(-1px)";
                e.currentTarget.style.boxShadow = `0 4px 14px rgba(26,26,46,0.35)`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = C.primary;
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = `0 2px 10px rgba(26,26,46,0.2)`;
              }}
            >
              <img
                src={user2}
                alt="User"
                style={{ width: "16px", height: "16px", objectFit: "contain", filter: "brightness(1.8) sepia(1) saturate(3) hue-rotate(10deg)" }}
              />
              {t("Login") || "Log in"}
            </button>
          )}
        </div>
      </div>

      {/* Language Menu */}
      <Menu
        anchorEl={langAnchorEl}
        open={langMenuOpen}
        onClose={handleLangMenuClose}
        PaperProps={{
          elevation: 3,
          sx: {
            minWidth: 150,
            borderRadius: 2,
            mt: 1.5,
            border: `1px solid ${C.border}`,
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          },
        }}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
      >
        {[
          { code: "sv", label: "Svenska" },
          { code: "en", label: "English" },
          { code: "ar", label: "العربية" },
        ].map(({ code, label }) => (
          <MenuItem
            key={code}
            onClick={() => handleLanguageChange(code)}
            selected={i18n.language === code}
            sx={{
              borderRadius: 1.5,
              mx: 0.5,
              my: 0.25,
              "&.Mui-selected": { backgroundColor: "rgba(201,168,76,0.1)" },
              "&:hover": { backgroundColor: "rgba(201,168,76,0.08)" },
            }}
          >
            <ListItemIcon>
              <Language fontSize="small" sx={{ color: i18n.language === code ? C.accent : C.textMuted }} />
            </ListItemIcon>
            <Typography variant="body2" fontWeight={i18n.language === code ? "700" : "500"}>
              {label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>

      {/* User Menu */}
      <Menu
        anchorEl={anchorEl}
        open={userMenuOpen}
        onClose={handleUserMenuClose}
        onClick={handleUserMenuClose}
        PaperProps={{
          elevation: 0,
          sx: {
            minWidth: 240,
            borderRadius: 3,
            mt: 1.5,
            border: `1px solid ${C.border}`,
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
            overflow: "visible",
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
              borderLeft: "1px solid",
              borderTop: "1px solid",
              borderColor: "divider",
            },
            "& .MuiMenuItem-root": {
              px: 2,
              py: 1.25,
              borderRadius: 1.5,
              mx: 1,
              my: 0.5,
              transition: "all 0.2s ease",
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {/* User info header */}
        <Box sx={{ px: 2.5, py: 2, mb: 0.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Avatar
              sx={{
                bgcolor: C.primary,
                color: C.accent,
                width: 44,
                height: 44,
                fontWeight: "700",
                fontSize: "18px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              }}
            >
              {User?.name?.charAt(0).toUpperCase() || "U"}
            </Avatar>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                variant="subtitle2"
                fontWeight="700"
                sx={{ mb: 0.25, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: C.primary }}
              >
                {User?.name || t("User")}
              </Typography>
              <Typography variant="caption" sx={{ fontSize: "12px", color: C.textMuted }}>
                {User?.phoneNumber}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Divider sx={{ my: 1, borderColor: C.border }} />

        <MenuItem
          onClick={handleMyAppointments}
          sx={{ "&:hover": { backgroundColor: "rgba(201,168,76,0.08) !important" } }}
        >
          <ListItemIcon>
            <CalendarToday fontSize="small" sx={{ color: C.accent }} />
          </ListItemIcon>
          <Typography variant="body2" fontWeight="500">
            {t("MyAppointments") || "My Appointments"}
          </Typography>
        </MenuItem>

        <Divider sx={{ my: 1, borderColor: C.border }} />

        <MenuItem
          onClick={handleLogout}
          sx={{ "&:hover": { backgroundColor: "rgba(239,68,68,0.08) !important" } }}
        >
          <ListItemIcon>
            <Logout fontSize="small" sx={{ color: "#ef4444" }} />
          </ListItemIcon>
          <Typography variant="body2" fontWeight="500" color="error">
            {t("Logout") || "Logout"}
          </Typography>
        </MenuItem>
      </Menu>

      <MPLoginWithPhoneNumberModal open={loginModalOpen} onClose={handleCloseLoginModal} />
    </>
  );
}
